import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=089695c9&scoped=true"
import script from "./customPage.vue?vue&type=script&lang=ts"
export * from "./customPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089695c9",
  null
  
)

export default component.exports